import { isBefore, startOfDay } from 'date-fns';

export const isValidDates = (moveIn, moveOut) => {
  if (!moveIn && !moveOut) {
    return true;
  }

  const today = startOfDay(new Date());
  const moveInDate = moveIn ? startOfDay(moveIn) : null;
  const moveOutDate = moveOut ? startOfDay(moveOut) : null;

  if (
    (moveInDate && isBefore(moveInDate, today)) ||
    (moveOutDate && (isBefore(moveOutDate, today) || isBefore(moveOutDate, moveInDate)))
  ) {
    return { isValid: false, error: 'Invalid date' };
  }

  return { isValid: true, error: null };
};
